import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/providers/auth-provider';
import { resolveTeamMemberIds } from '@/lib/team-scope';

export function useTeamMemberFilter() {
  const { userDetails } = useAuth();
  const isTeamLeader = userDetails?.role === 'team_leader';
  const [teamMemberIds, setTeamMemberIds] = useState<string[] | null>(null); // null = no filter (admin)
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    if (!isTeamLeader || !userDetails?.id) {
      setTeamMemberIds(null); // admin sees all
      setLoading(false);
      return () => {
        cancelled = true;
      };
    }

    setTeamMemberIds(null);
    setLoading(true);

    supabase
      .from('team_leader_assignments')
      .select('employee_id')
      .eq('team_leader_id', userDetails.id)
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) {
          console.error('Error loading team assignments:', error);
          setTeamMemberIds([]);
        } else {
          setTeamMemberIds((data || []).map(d => d.employee_id));
        }
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [isTeamLeader, userDetails?.id]);

  return {
    teamMemberIds: resolveTeamMemberIds(isTeamLeader, teamMemberIds),
    isTeamLeader,
    loading,
  };
}
